import * as React from "react";
import { forwardRef } from "react";
const SvgExpanded = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "Iconsax/Linear/arrowdown2" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", d: "M14.9386 6.7124L10.0486 11.6024C9.47109 12.1799 8.52609 12.1799 7.94859 11.6024L3.05859 6.7124", stroke: "#24262B", strokeWidth: 1.5, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })));
const ForwardRef = forwardRef(SvgExpanded);
export default ForwardRef;
